import React from 'react'
import EditDepartments from "../../components-user/manage-company/Departments";

export default function Departments() {
  return (
    <EditDepartments />
  )
}
